// Works in parallel with stepDisplay's stepInputState, FormSharedValuesActions saves the data to the store//
import FormSharedValuesActions from './constants';
import { IActionObject, IFieldValue } from './types';

const initialState: any = {};

export default function formSharedValueReducer(
  state: any = initialState,
  action: IActionObject
): object {
  const { data } = action;
  switch (action.type) {
    case FormSharedValuesActions.SET_VALUE_STATE:
      // Overwrites state with new field key-val pairs
      return {
        ...data.reduce(
          (accumulatorState: any, { fieldKey, fieldValue }: IFieldValue) =>
            Object.assign(accumulatorState, { [fieldKey]: fieldValue }),
          state
        ),
      };
    case FormSharedValuesActions.RESET_VALUES_STATE:
      // Resets to Empty Object
      return {};
    default:
      return state;
  }
}
